export default __webpack_public_path__ + "static/logos2026-aa5e5808427bc276c73263692ca0b2f2.webp";